import React, { Fragment, useState, useCallback } from 'react'; 
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { DeleteModal } from './deleteModal/DeleteModal'; 

const DeleteButton = ( { disabled, itemType, itemName, onDelete, buttonType, danger = false, 
    icon = false, superSafe = true, children, confirmMessage = false, item } ) => {
     
    const [ modalVisible, setModalVisible ] = useState( false );

    /**@ant-design/icons
     * Handle what happens when the user clicks confirm.
     */
    
    const handleDeleteItemConfirm = useCallback( () => {
        setModalVisible( false );
        onDelete( item );
    }, [ setModalVisible, onDelete, item ] );

    /**
     * Handle what happens when the user attempts to close or cancel out of the modal.
     */
    const handleDeleteItemCancel = useCallback( () => {
        setModalVisible( false );
    }, [ setModalVisible ] );
    
    return (
        <Fragment>
            <Button
                disabled={ disabled }
                type={ buttonType }
                danger={ danger }
                style={ { width: '100%' } }
                icon={ icon ? <DeleteOutlined /> : undefined } 
                onClick={ () => {
                    setModalVisible( true );
                } }
            >
                { children }
            </Button>
        
            { /* The modal that appears to get the user to confirm their deletion. */ }
            <DeleteModal
                visible={ modalVisible }
                title="Confirm Deletion"
                onOk={ handleDeleteItemConfirm }
                onCancel={ handleDeleteItemCancel }
                superSafe= { false }
            >
                { confirmMessage ? confirmMessage : 
                    <React.Fragment>
                        <p>Are you <i>sure</i> you want to permanently delete the { itemType } <b>{ itemName }</b>? 
                        All users who have progress in this item will <i>lose their progress</i>. This action cannot be undone.</p>
                        <p>All images that were a part of this object will still exist, they just won&apos;t be attached to this object anymore.</p>
                    </React.Fragment>
                }
            </DeleteModal>
        </Fragment>
    );
};

export default DeleteButton;
